import React from "react";
import { get } from "lodash";
import TableDetailRow from "MODULES/shared/components/DetailTable/Detail";
import { shortDate } from "LIB/formatters/date";
import T from "prop-types";

export function RejectionDetails({ purchaseOrder }) {
  if (!purchaseOrder.rejected) return null;

  return (
    <table className="table table-condensed">
      <tbody>
        <TableDetailRow
          label="Rejected At"
          value={shortDate(get(purchaseOrder, "rejection_details.rejected_at"))}
          renderIfPresent
        />
        <TableDetailRow
          label="Rejected By"
          value={get(purchaseOrder, "rejection_details.rejected_by")}
          renderIfPresent
        />
        <TableDetailRow
          label="Reason For Rejection"
          value={get(
            purchaseOrder,
            "rejection_details.rejection_reasons",
            []
          ).join("/")}
          renderIfPresent
        />
      </tbody>
    </table>
  );
}

RejectionDetails.propTypes = {
  purchaseOrder: T.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/RejectionDetails.jsx